import { Button, Flex, Spacing } from '@billy/design-system'
import { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingGenericStep } from '../EInvoicingStep/elements/EInvoicingGenericStep'
import { EInvoicingProgressBar } from '../EInvoicingStep/elements/EInvoicingProgressBar'
import { EInvoicingStepContainer } from '../EInvoicingStep/elements/EInvoicingStepContainer'

export const EInvoicingSelectIDTypeStep = () => {
  const { t } = useTranslation()

  const { goToStep } = useEInvoicingSetup()
  const { legalUnitEstablishment } = useEInvoicingSetup()

  const handleGoToUploadIDStep = useCallback(() => goToStep('UPLOAD_ID_FRONT'), [goToStep])
  const handleGoToUploadPassportStep = useCallback(() => goToStep('UPLOAD_PASSPORT'), [goToStep])

  return (
    <EInvoicingStepContainer
      headerContent={<EInvoicingProgressBar title={t('e_invoice.kyc.step.select_id.progress.title')} />}
    >
      <EInvoicingGenericStep
        title={t('e_invoice.kyc.step.select_id.title')}
        // @ts-expect-error forcing <Trans> here instead of a string
        bannerText={
          <Trans
            i18nKey="e_invoice.kyc.step.select_id.subtitle"
            values={{
              accountHolderName: `${legalUnitEstablishment?.accountHolderFirstName} ${legalUnitEstablishment?.accountHolderLastName}`,
            }}
            components={{ strong: <b /> }}
          />
        }
        bannerType="danger"
      >
        <Flex flexDirection="column" gap={Spacing.S24}>
          <Button variant="filled" onClick={handleGoToUploadIDStep} fullWidth>
            {t('e_invoice.kyc.step.select_id.cta.primary')}
          </Button>
          <Button variant="filled" onClick={handleGoToUploadPassportStep} fullWidth>
            {t('e_invoice.kyc.step.upload_passport.title')}
          </Button>
        </Flex>
      </EInvoicingGenericStep>
    </EInvoicingStepContainer>
  )
}
